import { LAYOUT_LIST, LAYOUT_PG_SIDE_BY_SIDE } from '@wix/communities-blog-client-common';
import { getIsMobile } from '../../../common/store/basic-params/basic-params-selectors';

export const getMyPostsLayoutType = (state) => (getIsMobile(state) ? LAYOUT_LIST : LAYOUT_PG_SIDE_BY_SIDE);
